import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { register, validateUsername } from '../../services/api';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [role, setRole] = useState('client_admin');
  const [error, setError] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const navigate = useNavigate();

  const handleUsernameBlur = async () => {
    if (username) {
      try {
        await validateUsername({ username });
        setUsernameError('');
      } catch (err) {
        setUsernameError(err.response?.data?.error || 'Username is not available');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await register({
        name,
        email,
        username,
        password,
        password_confirmation: confirmPassword,
        role,
      });
      console.log('Register response:', response);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      setName('');
      setEmail('');
      setUsername('');
      setPassword('');
      setConfirmPassword('');
      setRole('client_admin');
      setError('');
      navigate(response.data.redirect_url);
    } catch (err) {
      console.error('Register error:', err);
      const errorMessage = typeof err.response?.data?.error === 'object'
        ? Object.values(err.response.data.error)[0][0]
        : err.response?.data?.error || 'Registration failed';
      setError(errorMessage);
      setPassword('');
      setConfirmPassword('');
    }
  };

  return (
    <div className="register-page">
      <div className="register-card">
        <h2 className="register-title">Register</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Username</label>
            <input
              type="text"
              className="form-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onBlur={handleUsernameBlur}
              required
            />
            {usernameError && <div className="error-message">{usernameError}</div>}
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Confirm Password</label>
            <input
              type="password"
              className="form-input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Role</label>
            <select
              className="form-input"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              required
            >
              <option value="client_admin">Client Admin</option>
              <option value="client_user">Client User</option>
            </select>
          </div>
          <button type="submit" className="register-button">
            Register
          </button>
        </form>
        <p className="login-link">
          Already have an account?{' '}
          <span onClick={() => navigate('/login')} className="login-link-text">
            Login here
          </span>
        </p>
      </div>
      <style>
        {`
          .register-page {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            background: linear-gradient(135deg, #0f172a, #1e3a8a, #334155);
            font-family: 'Arial', sans-serif;
          }

          .register-card {
            background-color: #ffffff;
            padding: 2rem;
            border-radius: 30px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
            border: 2px solid #FF8C00;
            width: 400px;
            min-height: 600px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            position: relative;
            box-sizing: border-box;
          }

          .register-title {
            text-align: center;
            background: linear-gradient(to right, #FF4500, #FFA500);
            color: #ffffff;
            padding: 0.5rem 0;
            border-radius: 28px 28px 0 0;
            margin: -2rem -2rem 1rem -2rem;
            font-size: 1.5rem;
            font-weight: bold;
            border-bottom: none;
          }

          .form-group {
            margin-bottom: 1.2rem;
          }

          .form-label {
            display: block;
            color: #1C2526;
            font-size: 1rem;
            margin-bottom: 0.5rem;
          }

          .form-input {
            width: 100%;
            padding: 0.6rem;
            border: 1px solid #1C2526;
            border-radius: 5px;
            font-size: 1rem;
            color: #1C2526;
            background-color: #f9f9f9;
          }

          .form-input:focus {
            outline: none;
          }

          .register-button {
            width: 100%;
            padding: 0.8rem;
            background: linear-gradient(to right, #FF4500, #FFA500);
            border: none;
            border-radius: 5px;
            color: #ffffff;
            font-size: 1rem;
            font-weight: bold;
            cursor: pointer;
            transition: transform 0.2s ease, box-shadow 0.2s ease;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .error-message {
            color: #d32f2f;
            font-size: 0.9rem;
            text-align: center;
            margin-top: 0.5rem;
          }

          .login-link {
            text-align: center;
            margin-top: 1rem;
            color: #1C2526;
            font-size: 0.9rem;
          }

          .login-link-text {
            color: #FF4500;
            cursor: pointer;
            text-decoration: underline;
          }

          .login-link-text:hover {
            color: #FFA500;
          }
        `}
      </style>
    </div>
  );
};

export default Register;